import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';

// Desktop Work shows the main-model selection. Thinking and specialist
// intelligence belong inside its picker, rather than in the composer label.
export default function WorkModelTriggerContent({ label, autoApprove, compact, disabled, highlighted, colors }) {
  return <View style={[styles.trigger, compact && styles.compact,
    highlighted && !disabled && { backgroundColor: colors.solid_color_tertiary }, disabled && { opacity: 0.5 }]}>
    {!compact && <Icon name="bolt" size={12} color={colors.text_color_secondary} solid />}
    <Text size="s" numberOfLines={1} style={{ maxWidth: compact ? 104 : 180 }}>{label}</Text>
    {autoApprove && <Icon name="check" size={10} color={colors.text_color_secondary} />}
    <Icon name="chevron-down" size={8} color={colors.text_color_tertiary} />
  </View>;
}

const styles = StyleSheet.create({
  trigger: { flexShrink: 0, flexDirection: 'row', alignItems: 'center', height: 34, paddingLeft: 10, paddingRight: 6,
    borderRadius: 18, gap: 6, ...(Platform.OS === 'web' ? { cursor: 'pointer', userSelect: 'none' } : {}) },
  compact: { paddingLeft: 8, paddingRight: 4, gap: 4 },
});
